export const hrProfessional = {
  id: 'hr-professional',
  version: 2,
  renderer: 'enterprise',
  name: 'HR Professional Classic',
  layout: 'single-column',
  theme: 'slate-executive',
  density: 'compact',
  persona: ['consulting'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 45,
    visual: 20,
    executive: 25,
    student: 10
  },
  metadata: {
    industry: ['Human Resources', 'Talent Acquisition', 'Corporate HR'],
    companies: ['Workday', 'ADP', 'Mercer', 'Deloitte HR Consulting', 'Randstad', 'Robert Half'],
    ats: ['Workday', 'Taleo', 'SuccessFactors'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    columns: 1,
    experienceLevel: ['Mid-level', 'Senior', 'Executive'],
    careerStage: 'Professional',
    recommendedFor: ['HR Specialists', 'Talent Acquisition Managers', 'HR Business Partners', 'Recruiting Coordinators'],
    avoidFor: ['Software Engineers', 'Creative Designers', 'Academic CVs'],
    dna: ['HR-Traditional', 'ATS-Scannable', 'Corporate-Compliance', 'Inter-Sans', 'Slate-Professional'],
    metrics: {
      readingDifficulty: 96,
      scanningSpeed: 96,
      visualAppeal: 84
    },
    hiringManager: {
      firstImpression: "Polished, compliance-focused HR partner with structured experience",
      scanningStyle: "Linear scanning focusing on retention rates, hiring volume, training programs, and HR tools",
      preferredStructure: "Summary, experience, education, skills",
      dislikes: ["Objective statements", "Creative elements", "Spelling errors or inconsistent margins"]
    },
    strategy: {
      goal: "Pass Workday/Taleo ATS checks and project structured compliance authority",
      focus: "Retention rates, employee engagement scores, talent acquisition volume",
      avoid: ["Gimmicky design tokens", "Secondary columns"]
    },
    psychology: {
      coreTraits: ["Trust", "Compliance", "Structure", "Communication"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Start bullet points with strong HR action verbs (e.g. 'implemented', 'hired', 'streamlined'). Highlight retention metrics (e.g. 'reduced turnover rate by 15%') and compliance frameworks.",
      rewriteStyle: "Formal, compliance-focused, structured"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'education', 'skills']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '24px'
      }
    }
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'education', 'skills'],
  components: {
    header: 'personal-info',
    main: ['summary', 'experience', 'education', 'skills'],
  },
  capabilities: {
    photo: false,
    icons: false,
    multiColumn: false,
    colorAccent: false,
    atsOptimized: true,
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.06em',
    '--heading-weight': '700',
    '--border-thickness-heading': '2px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '22px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px'
  }
};
export default hrProfessional;
